module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1001-1fff978764fdec8e857c898fc5224b46.png";